module.exports = __webpack_public_path__ + "img/s3.e4a0a6b0.png";